import React from 'react';
import PrivateRoute from 'PrivateRoutes';
import { Component } from './components';

const routes = () => (
  <PrivateRoute exact path="/settings/sticky-group" component={Component} />
);

export default routes;



// WEBPACK FOOTER //
// src/modules/screens/settings/StickyAgent/routes.js